import React from 'react';

type MobileDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function MobileDrawer({ isOpen, onClose }: MobileDrawerProps) {
  // Calculate transform classes based on isOpen state
  const transformClass = isOpen ? 'translate-y-0' : 'translate-y-full';

  // Handle click outside the drawer content to close it
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/50 z-20 transition-opacity"
          onClick={handleBackdropClick}
        />
      )}
      {/* Drawer */}
      <div
        className={`md:hidden fixed bottom-0 left-0 right-0 bg-surface ${transformClass} transition-transform duration-300 rounded-t-xl shadow-lg z-30`}>
        <div
          className="w-16 h-1 bg-gray-600 mx-auto my-2 rounded-full"
          onClick={onClose}
        />
        <div className="p-4">
          <h3 className="font-medium mb-4">More options</h3>
          <div className="grid grid-cols-4 gap-4">
            <button className="flex flex-col items-center justify-center p-2">
              <div className="w-10 h-10 bg-background rounded-full flex items-center justify-center mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <line x1="3" y1="9" x2="21" y2="9"/>
                  <line x1="9" y1="21" x2="9" y2="9"/>
                </svg>
              </div>
              <span className="text-xs">Layout</span>
            </button>
            <button className="flex flex-col items-center justify-center p-2">
              <div className="w-10 h-10 bg-background rounded-full flex items-center justify-center mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="8.5" cy="7" r="4"></circle>
                  <line x1="20" y1="8" x2="20" y2="14"></line>
                  <line x1="23" y1="11" x2="17" y2="11"></line>
                </svg>
              </div>
              <span className="text-xs">Add</span>
            </button>
            <button className="flex flex-col items-center justify-center p-2">
              <div className="w-10 h-10 bg-background rounded-full flex items-center justify-center mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </div>
              <span className="text-xs">Record</span>
            </button>
            <button className="flex flex-col items-center justify-center p-2">
              <div className="w-10 h-10 bg-background rounded-full flex items-center justify-center mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </div>
              <span className="text-xs">More</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
